import { render } from "./ConfirmCredits.vue?vue&type=template&id=78780f86&scoped=true"
import script from "./ConfirmCredits.vue?vue&type=script&lang=js"
export * from "./ConfirmCredits.vue?vue&type=script&lang=js"

import "./ConfirmCredits.vue?vue&type=style&index=0&id=78780f86&lang=css"
import "./ConfirmCredits.vue?vue&type=style&index=1&id=78780f86&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78780f86"]])

export default __exports__